import ApiService from "./ApiService";

export default class LocalGovernmentService extends ApiService
{
    collection = 'local_governments'
}